module.exports = __webpack_public_path__ + "media/images/quote-black-749bceae13eee5f96c4f11ba16fd1af3.png";